import type { LeadSource } from "@sales-ops-amplify/shared";

/** Source chips shown on Accounts / Leads filter rails. */
export const WORKSPACE_SOURCE_OPTIONS: ReadonlyArray<{
  id: LeadSource;
  label: string;
}> = [
  { id: "csv", label: "CSV" },
  { id: "manual", label: "Manual" },
  { id: "apollo", label: "Apollo" },
  { id: "hubspot", label: "HubSpot" },
  { id: "salesforce", label: "Salesforce" },
  { id: "salesnav", label: "Sales Nav" },
  { id: "form", label: "Form" },
  { id: "outreach", label: "Outreach" },
  { id: "demo", label: "Demo" },
  { id: "referral", label: "Referral" },
];

/** Convert a date input (YYYY-MM-DD) to start-of-day ISO for createdAfter. */
export function dateInputToCreatedAfter(date: string): string | undefined {
  const t = date.trim();
  if (!t) return undefined;
  return `${t}T00:00:00.000Z`;
}

/** Convert a date input (YYYY-MM-DD) to end-of-day ISO for createdBefore. */
export function dateInputToCreatedBefore(date: string): string | undefined {
  const t = date.trim();
  if (!t) return undefined;
  return `${t}T23:59:59.999Z`;
}

/** Strip ISO createdAfter/Before back to YYYY-MM-DD for date inputs. */
export function isoToDateInput(iso?: string): string {
  if (!iso) return "";
  return iso.slice(0, 10);
}
